import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment-timezone';
import * as cronstrue from 'cronstrue';
import { Schedule } from '../../survey.Service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-task-schedulers',
  templateUrl: './task-schedulers.component.html',
  styleUrl: './task-schedulers.component.css'
})
export class TaskSchedulersComponent {
  fromHere: boolean = false;
  registerChange: boolean = false;

  constructor(public translate: TranslateService) {

  }

  @Input()
  get schedules(): Schedule[] {
    return this._schedules;
  }
  set schedules(value: any) {
    this.registerChange = false;
    if (value?.length >= 1 && this._selectedSchedule == -1) {
      this._selectedSchedule = 0;
    }

    this._schedules = value;
    this.registerChange = true;
  }
  private _schedules: Schedule[] = [];

  @Output()
  schedulesChange = new EventEmitter<Schedule[]>();

  performAction(event, where: string): boolean {
    var schedule = this.schedules[this.selectedSchedule];
    event.stopPropagation();
    switch (where) {
      case "before":
        this._schedules.splice(this.selectedSchedule, 0, this.blankSchedule(schedule));
        break;
      case "after":
        if (this._selectedSchedule + 1 == this._schedules.length) {
          this._schedules.push(this.blankSchedule(schedule));
          this._selectedSchedule = this._schedules.length - 1;
          return false;
        }

        this._schedules.splice(this._selectedSchedule + 1, 0, this.blankSchedule(schedule));
        this._selectedSchedule++;
        break;
    }

    return false;
  }

  setSelectedSchedule(index: number): boolean {
    this._selectedSchedule = index;
    return false;
  }

  blankSchedule(schedule: Schedule): Schedule {
    return new Schedule(schedule.timezone, false, schedule.start, schedule.end, "");
  }

  deleteAction() {
    this._schedules.splice(this.selectedSchedule, 1);
    if (this.selectedSchedule > this._schedules.length) {
      this._selectedSchedule--;
    }
  }

  @Input()
  get selectedSchedule(): number {
    return this._selectedSchedule;
  }
  set selectedSchedule(value: number) {
    this._selectedSchedule = value;
  }
  private _selectedSchedule: number = -1;

  scheduleUpdated(index: number, schedule: Schedule) {
    this._schedules[index] = schedule;
    this.schedulesChange.emit(this.schedules);
  }

  cronDescription(schedule: Schedule): string {
    if (schedule.cron === "0 0 1 1 *") {
      return "";
    }

    return " - " + schedule.cron;
  }

  cronBasicDescription(schedule: Schedule): string {
    if (schedule.cron === "0 0 1 1 *") {
      return "Once";
    }

    try {
      return cronstrue.toString(schedule.cron);
    }
    catch {
      return "";
    }
  }

}
